module.exports = __webpack_public_path__ + "static/media/more-horiz.d25bd63d.svg";